import React from "react";
import logo from "../images/logo.png";
import fb from "../images/fb.png";
import insta from "../images/insta.png";
import lind from "../images/in.png";
import Forgetimg from "./Forgetimg";
import Confirmimg from "./confirmpage";
import Logimg from "./logpimg";
import Forgot from "./forgot";
import { useNavigate } from "react-router-dom";
// import { useHistory } from 'react-router-dom';

const Loglayout = ({ children }) => {
  const navigate = useNavigate();
  const handleLinkClick = (d) => {
    navigate(d);
  };

  const token = localStorage.getItem("token");

  const home = () => {
    if (token) {
      navigate("/dashboard");
    } else {
      navigate("/");
    }
  };

  return (
    <section className="login-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-5">
            <div className="login-page-left">
              <div className="login-page-1">
                <img
                  src={logo}
                  className="logo-img"
                  alt=""
                  onClick={home}
                  style={{ cursor: "pointer" }}
                />
              </div>

              {children}
              <div className="login-page-3">
                <ul className="login-ul">
                  <li>
                    <a href="">
                      <img src={fb} alt="" />
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <img src={lind} alt="" />
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <img src={insta} alt="" />
                    </a>
                  </li>
                </ul>
                <p className="Need-help">
                  {" "}
                  <a
                    href="javascript:void(0)"
                    onClick={() => handleLinkClick("/privacy")}
                    className="text-white text-decoration-none"
                  >
                    Privacy policy
                  </a>
                </p>
                <p className="Need-help">
                  {" "}
                  <a
                    href="javascript:void(0)"
                    onClick={() => handleLinkClick("/terms")}
                    className="text-white text-decoration-none"
                  >
                    Terms of service
                  </a>
                </p>
                <p className="Need-help">
                  {" "}
                  <a
                    href="https://edubridge.org.uk/contact-us"
                    onClick={handleLinkClick}
                    target="_blank"
                    className="text-white text-decoration-none"
                  >
                    Need help?
                  </a>
                </p>
              </div>
            </div>
          </div>
          {(window.location.pathname === "/" ||
            window.location.pathname === "/signup") && <Logimg />}
          {window.location.pathname === "/newpassword" && <Confirmimg />}
          {window.location.pathname === "/forgot" && <Forgot />}
          {window.location.pathname === "/verifyotp" && <Forgetimg />}
        </div>
      </div>
    </section>
  );
};

export default Loglayout;
